import Close from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import { memo } from 'react'
import { useParams } from 'react-router'

import campaignContentPaths from './content/campaignContentPaths'
import FPPAP from './FPPAP'
import MuiModalRoute from './shared/MuiModalRoute'

const FPPAPModalRouteChild = (props: {
  modalOpen: boolean
  closeModal: () => void
}) => {
  // Params inside here are different than params outside of the render
  // prop. Funky.
  // Months later... ESLINT doesn't like hooks used inside what it deams are callbacks.
  // in reality, it's just a Component...
  const params = useParams<{ id?: string; campaignId?: string }>()
  const campaignId = params.id || params.campaignId

  if (campaignId) {
    return (
      <Dialog
        fullScreen
        keepMounted={false}
        onClose={props.closeModal}
        open={props.modalOpen}
        scroll="paper"
      >
        <FPPAP
          campaignId={campaignId}
          extraButtons={
            <IconButton
              data-testid="closeButton"
              onClick={props.closeModal}
              size="large"
            >
              <Close />
            </IconButton>
          }
          isDialog
        />
      </Dialog>
    )
  } else {
    return null
  }
}

// TODO You really want to wrap MuiModalRoute's in their own, memoized,
// component, lest you suffer an endless cycle of renders.
// Either MuiModalRoute.children or Route.render in MuiModalRoute needs to be
// extracted somewhere so it's not a new function each render.
const FPPAPModalRoute = ({ path }: { path: string }) => {
  return (
    <MuiModalRoute
      children={FPPAPModalRouteChild}
      exact
      path={path || campaignContentPaths.activatePaidCampaign.path}
      returnToParent
    />
  )
}

export default memo(FPPAPModalRoute)
